export const TEXT_AREA = "Textarea";
export const MULTIPLE_CHOICE = "Multiple choice";
export const STAR_RATING = "Star rating";
export const SCALE_TYPE = "Scale type";
export const PREFERENCE_PRIORITY = "Preference priority";
export const YES_NO = "Radio answer";
export const YES_NO_COMMENT = "Radio answer with comment textarea";
export const FILE_UPLOAD = "File upload";
